import { SAVE_WEDDING, UPDATE_QUESTION, UPDATE_ANSWERS, UPDATE_ABOUT_US, SAVE_CONTACT_CONFIRMATION } from "../ActionsType";

export const SaveWedding = wedding => {
  return {
    type: SAVE_WEDDING,
    wedding
  };
};

export const DeleteWedding = () => {
  return {
    type: SAVE_WEDDING,
    wedding: {}
  };
};

export const updateQuestionAction = (section, data) => {
  return {
    type: UPDATE_QUESTION,
    section,
    data
  };
};

export const updateAnswersAction = (answers) => {
  return {
    type: UPDATE_ANSWERS,
    answers
  };
};

export const updateAboutUsAction = (data) => {
  return {
    type: UPDATE_ABOUT_US,
    data
  };
};

export const SaveContactConfirmation = (data) => {
  return {
    type: SAVE_CONTACT_CONFIRMATION,
    data
  };
};